import * as Types from '../../types/gql';

export type ExchangeRatesVariables = Types.Exact<{ [key: string]: never }>;

export type ExchangeRates = {
  clearing?: Types.Maybe<{ RUBUSD?: Types.Maybe<number>; USDRUB?: Types.Maybe<number> }>;
};
